export enum EnumTipoTarea {
    Emergencia = 1,
    Correctivo = 2,
    Preventivo = 3,
    Acompanamiento = 4
}

export const TipoTareaLabels = {
    [EnumTipoTarea.Emergencia]: "Emergencia",
    [EnumTipoTarea.Correctivo]: "Correctivo",
    [EnumTipoTarea.Preventivo]: "Preventivo",
    [EnumTipoTarea.Acompanamiento]: "Acompañamiento"
};

